import { render, staticRenderFns } from "./ActRead.vue?vue&type=template&id=0c129148&"
import script from "./ActRead.vue?vue&type=script&lang=js&"
export * from "./ActRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports